import Skeleton from 'react-loading-skeleton';
import 'react-loading-skeleton/dist/skeleton.css';

export function ProductCardSkeleton() {
    return (
        <div className="modelContainer eligible">
            <span className="groupThumbContainer">
                <Skeleton height={150} />
            </span>
            <span className="modelHeadline"><Skeleton width="40%" /></span>
            <span className="modelNameHeadline"><Skeleton width="70%" /></span>
            <span className="modelDescription"><Skeleton count={2} /></span>
            <span className="modelHPMsrpContainer">
                <Skeleton width="50%" height={20} />
            </span>
            <Skeleton height={32} borderRadius={4} />
        </div>
    );
}

export function ProductGridSkeleton() {
    return (
        <div className="groupContainerContent skeletonGrid">
            {Array.from({ length: 5 }, (_, i) => (
                <ProductCardSkeleton key={i} />
            ))}
        </div>
    );
}

export function ConfiguratorSkeleton() {
    return (
        <div id="build_details_container" className="wholegoods contentContainer step4 active">
            <div id="build_details_container_image_and_payments" className="buildImagesPaymentsContainer">
                <div id="build_details_container_main_image" className="mainImageContainer active">
                    <Skeleton height={300} />
                </div>
                <Skeleton height={60} />
            </div>
            <div id="build_details_container_selection" className="detailsContainer">
                <h1 className="buildDetailsHeader detailsContainerContent wholegoodsPanel addonsPanel summaryPanel sendquotePanel quoteSentPanel bottomBorder active">
                    <Skeleton width="60%" />
                </h1>
                {[1, 2, 3].map(i => (
                    <div key={i} className="groupList bottomBorder">
                        <div className="groupListHeader"><Skeleton width="40%" /></div>
                        <Skeleton count={3} height={40} style={{ marginBottom: '0.5rem' }} />
                    </div>
                ))}
            </div>
        </div>
    );
}
